import { render, staticRenderFns } from "./response.vue?vue&type=template&id=a621956c"
import script from "./response.vue?vue&type=script&lang=ts"
export * from "./response.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports